const CAMERA_CATEGORIES = [
    'SLR',
    'Rangefinder',
    'TLR',
    'Point & Shoot',
    'Medium Format',
    'Large Format',
    'Instant',
    'Movie Camera',
    'Lens',
    'Accessory',
    'Film',
    'Other',
];
const CAMERA_BRANDS = [
    'Bronica',
    'Canon',
    'Contax',
    'Fujifilm',
    'Graflex',
    'Hasselblad',
    'Konica',
    'Leica',
    'Linhof',
    'Mamiya',
    'Minolta',
    'Nikon',
    'Olympus',
    'Pentax',
    'Polaroid',
    'Praktica',
    'Rolleiflex',
    'Voigtlander',
    'Yashica',
    'Other',
];
const CAMERA_CATEGORY_BRANDS = {
    SLR: ['Nikon', 'Canon', 'Pentax', 'Minolta', 'Olympus', 'Contax', 'Praktica', 'Other'],
    Rangefinder: ['Leica', 'Canon', 'Voigtlander', 'Contax', 'Nikon', 'Konica', 'Yashica', 'Other'],
    TLR: ['Rolleiflex', 'Yashica', 'Mamiya', 'Other'],
    'Medium Format': ['Hasselblad', 'Mamiya', 'Bronica', 'Pentax', 'Fujifilm', 'Other'],
    'Large Format': ['Graflex', 'Linhof', 'Other'],
    Instant: ['Polaroid', 'Fujifilm', 'Other'],
    Lens: ['Nikon', 'Canon', 'Leica', 'Pentax', 'Olympus', 'Minolta', 'Voigtlander', 'Other'],
};
const CAMERA_BRAND_MODELS = {
    Nikon: ['F', 'F2', 'F3', 'FM2', 'FE2', 'FM3A', 'FA', 'Nikkormat FT2', 'S2', 'S3', 'SP'],
    Canon: ['AE-1', 'A-1', 'F-1', 'EF', 'Canonet QL17', 'P', '7'],
    Leica: ['M3', 'M2', 'M4', 'M6', 'M4-P', 'IIIf', 'IIIg', 'CL', 'R3'],
    Hasselblad: ['500C', '500C/M', '503CX', 'SWC', '2000FC'],
    Pentax: ['K1000', 'Spotmatic', 'LX', 'MX', '67', '645'],
    Olympus: ['OM-1', 'OM-2', 'OM-3Ti', 'OM-4Ti', 'XA', 'Trip 35'],
    Minolta: ['SRT-101', 'X-700', 'XD-11', 'CLE', 'Hi-Matic 7s'],
    Mamiya: ['RB67', 'RZ67', 'C330', '7II', '645 Pro'],
    Rolleiflex: ['2.8F', '2.8E', '3.5F', 'T', 'Automat'],
    Contax: ['RTS', 'RTS II', 'Aria', 'G1', 'G2', 'T2', 'T3'],
    Polaroid: ['SX-70', '680', 'Spectra', 'Land Camera 195'],
};
const CAMERA_SUBCATEGORIES = {
    SLR: ['35mm', 'APS'],
    Rangefinder: ['35mm', 'Medium Format'],
    Lens: ['Wide Angle', 'Standard', 'Telephoto', 'Macro', 'Zoom', 'Fisheye'],
    Film: ['35mm', '120', '4x5', '8x10', 'Instant', 'APS'],
    Accessory: ['Filter', 'Flash', 'Tripod', 'Light Meter', 'Case', 'Strap', 'Viewfinder'],
};
export const vintageCamerasVaultType = {
    id: 'vintage_cameras',
    label: 'Vintage Cameras',
    tagline: 'Document your analog photography collection',
    icon: 'Camera',
    platformLabel: 'Brand',
    categories: CAMERA_CATEGORIES,
    brands: CAMERA_BRANDS,
    brandModels: CAMERA_BRAND_MODELS,
    categoryBrands: CAMERA_CATEGORY_BRANDS,
    subcategories: CAMERA_SUBCATEGORIES,
    conditions: ['mint', 'excellent', 'good', 'fair', 'poor', 'parts'],
    specializedFields: [
        { key: 'lens_mount', label: 'Lens Mount', type: 'text', placeholder: 'e.g. Nikon F, Canon FD' },
        { key: 'focal_length', label: 'Focal Length', type: 'text', placeholder: 'e.g. 50mm' },
        { key: 'aperture_range', label: 'Aperture Range', type: 'text', placeholder: 'e.g. f/1.4 - f/16' },
        { key: 'shutter_speed_range', label: 'Shutter Speed Range', type: 'text', placeholder: 'e.g. 1s - 1/1000s' },
        { key: 'film_format', label: 'Film Format', type: 'select', options: ['35mm', '120', '4x5', '8x10', 'Instant', 'APS', 'Other'] },
        { key: 'meter_type', label: 'Meter Type', type: 'select', options: ['CdS', 'SPD', 'GPD', 'None', 'External', 'Other'] },
    ],
    specializedFeatures: {
        cla_tracking: true,
        light_seal: true,
    },
    aiSystemPrompt: `You are an expert in vintage and analog cameras. Analyze the provided image and identify the camera or lens. Provide details including: the manufacturer/brand, model name, approximate year of manufacture, category (SLR, Rangefinder, TLR, Lens, etc.), film format, lens mount, condition assessment, and any notable features like built-in meter type, special coatings, or limited editions. If you can identify specific components or modifications, mention those.`,
    maintenanceAlertTypes: [
        'cla_service',
        'light_seal_replacement',
        'meter_calibration',
        'shutter_service',
        'custom',
    ],
    fileTypes: ['manual_pdf', 'schematic', 'other'],
    defaultThemes: ['cyanotype', 'darkroom', 'chrome_leather', 'kodachrome', 'film_noir'],
};
//# sourceMappingURL=vintageCameras.js.map